// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkBoxSwitcher-module_disabled__RSKWW {
    cursor: default;
    pointer-events: none;
}
.checkBoxSwitcher-module_checkboxInput__LV1dC {
    opacity: 0;
    position: absolute;
    z-index: -1;
}

.checkBoxSwitcher-module_checkboxIndicator__XsxqM {
    border: 2px solid var(--grey_40_lc);
    border-radius: 3px;
    display: inline-block;
    height: 20px;
    width: 20px;
    min-width: 20px;
    box-sizing: border-box;
    position: relative;
}

.checkBoxSwitcher-module_checkboxTickWrap__dMfq6 {
    position: absolute;
    left: -2px;
    top: -2px;
    display: none;
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
}

@media (hover: hover) and (pointer: fine) {
    .checkBoxSwitcher-module_checkboxLabel__wlkCW:hover .checkBoxSwitcher-module_checkboxIndicator__XsxqM {
        border-color: var(--grey_72_lc);
    }
}

@media (hover: hover) and (pointer: fine) {
    .checkBoxSwitcher-module_checkboxLabel__wlkCW:hover .checkBoxSwitcher-module_checkboxInput__LV1dC:checked + .checkBoxSwitcher-module_checkboxIndicator__XsxqM {
        background: var(--purple_72_lc);
        border-color: var(--purple_72_lc);
    }
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW .checkBoxSwitcher-module_checkboxInput__LV1dC:checked + .checkBoxSwitcher-module_checkboxIndicator__XsxqM {
    background: var(--purple_100);
    border-color: var(--purple_100);
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW .checkBoxSwitcher-module_checkboxInput__LV1dC:checked + .checkBoxSwitcher-module_checkboxIndicator__XsxqM .checkBoxSwitcher-module_checkboxTickWrap__dMfq6 {
    display: inline-block;
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW .checkBoxSwitcher-module_checkboxInput__LV1dC[disabled] + .checkBoxSwitcher-module_checkboxIndicator__XsxqM {
    border-color: var(--grey_8_lc);
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW .checkBoxSwitcher-module_checkboxInput__LV1dC[disabled] {
    cursor: not-allowed;
}

.checkBoxSwitcher-module_checkboxLabel__wlkCW .checkBoxSwitcher-module_checkboxInput__LV1dC[disabled]:checked + .checkBoxSwitcher-module_checkboxIndicator__XsxqM {
    background: var(--purple_40_tr);
    border-color: transparent;
}

.checkBoxSwitcher-module_switchInputBlock__sK0zo {
    display: flex;
    justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Checkbox/checkBoxSwitcher.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,iCAAiC;IACrC;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".disabled {\n    cursor: default;\n    pointer-events: none;\n}\n.checkboxInput {\n    opacity: 0;\n    position: absolute;\n    z-index: -1;\n}\n\n.checkboxIndicator {\n    border: 2px solid var(--grey_40_lc);\n    border-radius: 3px;\n    display: inline-block;\n    height: 20px;\n    width: 20px;\n    min-width: 20px;\n    box-sizing: border-box;\n    position: relative;\n}\n\n.checkboxTickWrap {\n    position: absolute;\n    left: -2px;\n    top: -2px;\n    display: none;\n}\n\n.checkboxLabel {\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .checkboxLabel:hover .checkboxIndicator {\n        border-color: var(--grey_72_lc);\n    }\n}\n\n@media (hover: hover) and (pointer: fine) {\n    .checkboxLabel:hover .checkboxInput:checked + .checkboxIndicator {\n        background: var(--purple_72_lc);\n        border-color: var(--purple_72_lc);\n    }\n}\n\n.checkboxLabel .checkboxInput:checked + .checkboxIndicator {\n    background: var(--purple_100);\n    border-color: var(--purple_100);\n}\n\n.checkboxLabel .checkboxInput:checked + .checkboxIndicator .checkboxTickWrap {\n    display: inline-block;\n}\n\n.checkboxLabel .checkboxInput[disabled] + .checkboxIndicator {\n    border-color: var(--grey_8_lc);\n}\n\n.checkboxLabel .checkboxInput[disabled] {\n    cursor: not-allowed;\n}\n\n.checkboxLabel .checkboxInput[disabled]:checked + .checkboxIndicator {\n    background: var(--purple_40_tr);\n    border-color: transparent;\n}\n\n.switchInputBlock {\n    display: flex;\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `checkBoxSwitcher-module_disabled__RSKWW`,
	"checkboxInput": `checkBoxSwitcher-module_checkboxInput__LV1dC`,
	"checkboxIndicator": `checkBoxSwitcher-module_checkboxIndicator__XsxqM`,
	"checkboxTickWrap": `checkBoxSwitcher-module_checkboxTickWrap__dMfq6`,
	"checkboxLabel": `checkBoxSwitcher-module_checkboxLabel__wlkCW`,
	"switchInputBlock": `checkBoxSwitcher-module_switchInputBlock__sK0zo`
};
export default ___CSS_LOADER_EXPORT___;
